module.exports = __webpack_public_path__ + "img/register-img-1.7352c8d9.png";